<form (ngSubmit)="onSubmit()" [formGroup]="formGroup" class="licence-plate">
  <div [style.background-color]="plateColor" class="licence-plate-country">
    <ng-container *ngIf="useFlag; else notUsingFlag">
      <img class="transition relative h-5 w-5 rounded-full" src="assets/flags/{{ countryCode }}.svg" />
    </ng-container>
    <ng-template #notUsingFlag>
      <svg
        class="licence-plate-europe"
        fill="#FFCC00"
        height="24"
        viewBox="0 0 300 300"
        width="24"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M150 10L143.82 29.0211L153.33 32.1113" />
        <path d="M150 10L156.18 29.0211L146.67 32.1113" />
        <path d="M169.021 23.8196H149.021V33.8196" />
        <path d="M169.021 23.8196L152.841 35.5753L146.963 27.4851" />
        <path d="M161.756 46.1804L155.575 27.1593L146.065 30.2495" />
        <path d="M161.756 46.1804L145.575 34.4247L151.453 26.3345" />
        <path d="M138.244 46.1803L154.425 34.4246L148.547 26.3344" />
        <path d="M138.244 46.1803L144.425 27.1592L153.935 30.2493" />
        <path d="M130.979 23.8197L147.159 35.5754L153.037 27.4852" />
        <path d="M130.979 23.8197H150.979V33.8197" />
        <path d="M210 26.077L203.82 45.0982L213.33 48.1883" />
        <path d="M210 26.077L216.18 45.0982L206.67 48.1883" />
        <path d="M229.021 39.8966H209.021V49.8966" />
        <path d="M229.021 39.8966L212.841 51.6523L206.963 43.5621" />
        <path d="M221.756 62.2574L215.575 43.2363L206.065 46.3265" />
        <path d="M221.756 62.2574L205.575 50.5017L211.453 42.4116" />
        <path d="M198.244 62.2573L214.425 50.5016L208.547 42.4114" />
        <path d="M198.244 62.2573L204.425 43.2362L213.935 46.3264" />
        <path d="M190.979 39.8967L207.159 51.6524L213.037 43.5623" />
        <path d="M190.979 39.8967H210.979V49.8967" />
        <path d="M253.923 70L247.743 89.0211L257.253 92.1113" />
        <path d="M253.923 70L260.103 89.0211L250.593 92.1113" />
        <path d="M272.944 83.8196H252.944V93.8196" />
        <path d="M272.944 83.8196L256.764 95.5753L250.886 87.4851" />
        <path d="M265.679 106.18L259.498 87.1593L249.988 90.2495" />
        <path d="M265.679 106.18L249.498 94.4247L255.376 86.3345" />
        <path d="M242.167 106.18L258.348 94.4246L252.47 86.3344" />
        <path d="M242.167 106.18L248.348 87.1592L257.858 90.2493" />
        <path d="M234.902 83.8197L251.082 95.5754L256.96 87.4852" />
        <path d="M234.902 83.8197H254.902V93.8197" />
        <path d="M270 130L263.82 149.021L273.33 152.111" />
        <path d="M270 130L276.18 149.021L266.67 152.111" />
        <path d="M289.021 143.82H269.021V153.82" />
        <path d="M289.021 143.82L272.841 155.575L266.963 147.485" />
        <path d="M281.756 166.18L275.575 147.159L266.065 150.249" />
        <path d="M281.756 166.18L265.575 154.425L271.453 146.335" />
        <path d="M258.244 166.18L274.425 154.425L268.547 146.334" />
        <path d="M258.244 166.18L264.425 147.159L273.935 150.249" />
        <path d="M250.979 143.82L267.159 155.575L273.037 147.485" />
        <path d="M250.979 143.82H270.979V153.82" />
        <path d="M253.923 190L247.743 209.021L257.253 212.111" />
        <path d="M253.923 190L260.103 209.021L250.593 212.111" />
        <path d="M272.944 203.82H252.944V213.82" />
        <path d="M272.944 203.82L256.764 215.575L250.886 207.485" />
        <path d="M265.679 226.18L259.498 207.159L249.988 210.249" />
        <path d="M265.679 226.18L249.498 214.425L255.376 206.335" />
        <path d="M242.167 226.18L258.348 214.425L252.47 206.334" />
        <path d="M242.167 226.18L248.348 207.159L257.858 210.249" />
        <path d="M234.902 203.82L251.082 215.575L256.96 207.485" />
        <path d="M234.902 203.82H254.902V213.82" />
        <path d="M210 233.923L203.82 252.944L213.33 256.034" />
        <path d="M210 233.923L216.18 252.944L206.67 256.034" />
        <path d="M229.021 247.743H209.021V257.743" />
        <path d="M229.021 247.743L212.841 259.498L206.963 251.408" />
        <path d="M221.756 270.103L215.575 251.082L206.065 254.172" />
        <path d="M221.756 270.103L205.575 258.348L211.453 250.258" />
        <path d="M198.244 270.103L214.425 258.348L208.547 250.257" />
        <path d="M198.244 270.103L204.425 251.082L213.935 254.172" />
        <path d="M190.979 247.743L207.159 259.498L213.037 251.408" />
        <path d="M190.979 247.743H210.979V257.743" />
        <path d="M150 250L143.82 269.021L153.33 272.111" />
        <path d="M150 250L156.18 269.021L146.67 272.111" />
        <path d="M169.021 263.82H149.021V273.82" />
        <path d="M169.021 263.82L152.841 275.575L146.963 267.485" />
        <path d="M161.756 286.18L155.575 267.159L146.065 270.249" />
        <path d="M161.756 286.18L145.575 274.425L151.453 266.335" />
        <path d="M138.244 286.18L154.425 274.425L148.547 266.334" />
        <path d="M138.244 286.18L144.425 267.159L153.935 270.249" />
        <path d="M130.979 263.82L147.159 275.575L153.037 267.485" />
        <path d="M130.979 263.82H150.979V273.82" />
        <path d="M90 233.923L83.8197 252.944L93.3302 256.034" />
        <path d="M90 233.923L96.1803 252.944L86.6698 256.034" />
        <path d="M109.021 247.743H89.0211V257.743" />
        <path d="M109.021 247.743L92.8408 259.498L86.9629 251.408" />
        <path d="M101.756 270.103L95.5754 251.082L86.0648 254.172" />
        <path d="M101.756 270.103L85.5754 258.348L91.4533 250.258" />
        <path d="M78.2443 270.103L94.4246 258.348L88.5467 250.257" />
        <path d="M78.2443 270.103L84.4246 251.082L93.9352 254.172" />
        <path d="M70.9789 247.743L87.1592 259.498L93.0371 251.408" />
        <path d="M70.9789 247.743H90.9789V257.743" />
        <path d="M46.077 190L39.8967 209.021L49.4073 212.111" />
        <path d="M46.077 190L52.2574 209.021L42.7468 212.111" />
        <path d="M65.0981 203.82H45.0981V213.82" />
        <path d="M65.0981 203.82L48.9178 215.575L43.04 207.485" />
        <path d="M57.8326 226.18L51.6523 207.159L42.1417 210.249" />
        <path d="M57.8326 226.18L41.6523 214.425L47.5302 206.335" />
        <path d="M34.3213 226.18L50.5016 214.425L44.6238 206.334" />
        <path d="M34.3213 226.18L40.5016 207.159L50.0122 210.249" />
        <path d="M27.0559 203.82L43.2362 215.575L49.1141 207.485" />
        <path d="M27.0559 203.82H47.0559V213.82" />
        <path d="M30 130L23.8197 149.021L33.3302 152.111" />
        <path d="M30 130L36.1803 149.021L26.6698 152.111" />
        <path d="M49.0211 143.82H29.0211V153.82" />
        <path d="M49.0211 143.82L32.8408 155.575L26.9629 147.485" />
        <path d="M41.7557 166.18L35.5754 147.159L26.0648 150.249" />
        <path d="M41.7557 166.18L25.5754 154.425L31.4533 146.335" />
        <path d="M18.2443 166.18L34.4246 154.425L28.5467 146.334" />
        <path d="M18.2443 166.18L24.4246 147.159L33.9352 150.249" />
        <path d="M10.9789 143.82L27.1592 155.575L33.0371 147.485" />
        <path d="M10.9789 143.82H30.9789V153.82" />
        <path d="M46.077 70L39.8967 89.0211L49.4073 92.1113" />
        <path d="M46.077 70L52.2574 89.0211L42.7468 92.1113" />
        <path d="M65.0981 83.8196H45.0981V93.8196" />
        <path d="M65.0981 83.8196L48.9178 95.5753L43.04 87.4851" />
        <path d="M57.8326 106.18L51.6523 87.1593L42.1417 90.2495" />
        <path d="M57.8326 106.18L41.6523 94.4247L47.5302 86.3345" />
        <path d="M34.3213 106.18L50.5016 94.4246L44.6238 86.3344" />
        <path d="M34.3213 106.18L40.5016 87.1592L50.0122 90.2493" />
        <path d="M27.0559 83.8197L43.2362 95.5754L49.1141 87.4852" />
        <path d="M27.0559 83.8197H47.0559V93.8197" />
        <path d="M90 26.077L83.8197 45.0982L93.3302 48.1883" />
        <path d="M90 26.077L96.1803 45.0982L86.6698 48.1883" />
        <path d="M109.021 39.8966H89.0211V49.8966" />
        <path d="M109.021 39.8966L92.8408 51.6523L86.9629 43.5621" />
        <path d="M101.756 62.2574L95.5754 43.2363L86.0648 46.3265" />
        <path d="M101.756 62.2574L85.5754 50.5017L91.4533 42.4116" />
        <path d="M78.2443 62.2573L94.4246 50.5016L88.5467 42.4114" />
        <path d="M78.2443 62.2573L84.4246 43.2362L93.9352 46.3264" />
        <path d="M70.9789 39.8967L87.1592 51.6524L93.0371 43.5623" />
        <path d="M70.9789 39.8967H90.9789V49.8967" />
      </svg>
    </ng-template>
    {{ countryCode | uppercase }}
  </div>
  <input
    [placeholder]="platePlaceholder | translate"
    class="licence-plate-input data-hj-allow"
    formControlName="licensePlate"
    id="license-plate-input"
    type="text" />
  <button
    [class.cursor-not-allowed]="isDisabled"
    [disabled]="isDisabled"
    [id]="user ? '' : 'track-funnel-start'"
    [innerHTML]="cta | translate"
    [style.background-color]="backgroundColor"
    [style.color]="textColor"
    class="licence-plate-button"
    id="licence-plate-button"
    type="submit"></button>
</form>
<p *ngIf="isInvalidControl('licensePlate')" class="text-center sm:text-left mt-3 text-base font-semibold text-red-500">
  {{ 'SHARED.INPUT_LICENSE_PLATE.INPUT_ERROR' | translate }}
</p>
